import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { USE_GLOBAL_SPINNER } from '@digital-platform/rs-shared/services';
import { SHOULD_ATTACH_ACCESS_TOKEN } from '@digital-platform/rs-signup/services';
import { UwpWasteProfile } from '@digital-platform/unified-wp-waste-profile/domain';

interface WasteProfileListResponse {
  wasteProfiles: UwpWasteProfile[];
  status: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class WasteProfileRepositoryService {
  private httpClient: HttpClient = inject(HttpClient);

  public getWasteProfileList(): Observable<UwpWasteProfile[]> {
    const context = new HttpContext()
      .set(SHOULD_ATTACH_ACCESS_TOKEN, true)
      .set(USE_GLOBAL_SPINNER, true);

    return this.httpClient
      .get<WasteProfileListResponse>(`/api/uwp/comp/profiles/list`, { context })
      .pipe(
        map((profiles) =>
          profiles?.wasteProfiles ? profiles.wasteProfiles : []
        )
      );
  }
}
